import File from './File.js'

export default (sImage, index, section) => ({
	allowedTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
	maxSize: 5000000, // 5mb upload size limit
	editCaption: false,
	didInit: false,
	init() {
		// Watchers
		this.$watch('image.caption', (newVal, oldVal) => {
			if (oldVal === '' && !this.didInit) {
				this.didInit = true
			} else {
				this.image.didChange = true
				this.update()
			}
		})
	},
	get editCaptionButtonText() {
		if (this.editCaption) {
			return 'Save'
		}
		if (this.image.caption === '') {
			return 'Add Caption'
		}
		return 'Edit'
	},
	image: {
		content: '',
		filename: '',
		didChange: false,
		error: false,
		order: index,
		caption: ''
	},
	async dropFile(evt) {
		const files = evt.dataTransfer.files;
		if (!files)	 {return}
		if (files.length === 0) {return}
		for (const file of files) {
			if (!this.allowedTypes.includes(file.type)) {
				this.error = 'We do not accept this kind of image.'
				return
			}
			if (file.size > this.maxSize) {
				this.error = 'Your image exceeds our maximum file size of 10Mb.'
				return
			}
		}
		const file = files[0]
		this.image.filename = file.name
		this.image.content = await File.readFile(file)
		this.image.didChange = true
		
		if(files.length > 1) {
			const spliced = Array.from(files)
			spliced.splice(0, 1);
			const nFiles = []
			for (const file of spliced) {
				nFiles.push({
					filename: file.name,
					content: await File.readFile(file),
					didChange: true,
					iid: File.makeUUID(),
					caption: ''
				})
			}
			this.$dispatch('addmultiple', {section, images: nFiles})
		}
		this.update()
	},

	update() {
		this.$dispatch('update', { index, image: this.image, section})
	},
	clickSelect() {
		const input = document.createElement('input')
		input.type = 'file'
		input.accept = this.allowedTypes.join(',')
		input.multiple = false
		input.onchange = (event) => {
			this.dropFile({dataTransfer: {files: event.target.files}})
		}
		input.click()
	},
})